import { getClientSessionId, getHeaders } from '@/server/server';

export interface ProviderConfig {
    clientId: string;
    issuer: string;
    scope: string;
    acrValues: string;
}

export interface AuthConfig {
    employee: ProviderConfig;
    idporten: ProviderConfig;
}

let authConfig: AuthConfig | null = null;
let apiBaseUrl: string | null = null;

export async function loadAuthConfig(apiUrl: string): Promise<AuthConfig | null> {
    apiBaseUrl = apiUrl;
    try {
        const response = await fetch(`${apiUrl}/api/v1/auth-config`, {
            headers: getHeaders(getClientSessionId()),
            mode: 'cors',
        });
        if (response.ok) {
            authConfig = await response.json();
        } else {
            console.error(
                'Failed to load auth config:',
                response.status,
                response.statusText
            );
        }
    } catch (error) {
        console.error('Failed to load auth config:', error);
    }
    return authConfig;
}

export function getAuthConfig(): AuthConfig | null {
    return authConfig;
}

export function getApiBaseUrl(): string | null {
    return apiBaseUrl;
}
